'use client';

import React from 'react';
import {useHydrated} from '@/hooks/useHydrated';

import {Toaster} from 'sonner';

export const SonnerProvider: React.FC = () => {
    const mounted = useHydrated();

    if (!mounted) {
        return null;
    }

    return (
        <Toaster
            position="top-right"
            richColors
            closeButton
            expand
            duration={4000}
            visibleToasts={3}
            theme="light"
            toastOptions={{
                style: {
                    borderRadius: '12px',
                    fontSize: '14px',
                    fontFamily: 'var(--font-outfit)',
                    padding: '16px',
                    minHeight: '60px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(16px)',
                    cursor: 'pointer',
                },
                className: 'sonner-toast',
                actionButtonStyle: {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    color: 'inherit',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    fontSize: '12px',
                    fontWeight: '500',
                    cursor: 'pointer',
                },
                cancelButtonStyle: {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    color: 'inherit',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    fontSize: '12px',
                    cursor: 'pointer',
                }
            }}
        />
    );
};

export default SonnerProvider;
